import styled from "@emotion/styled";

export const CadastrarClienteForm = styled.form`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
`